const MainSearch = class extends HTMLElement {
  constructor() {
    super();

    // Clicking close button
    this.querySelectorAll('.main-search__close').forEach((el) => {
      el.addEventListener('click', (evt) => {
        evt.preventDefault();
        document.body.classList.remove('show-search');
      });
    });

    // Pressing escape key
    this.querySelector('.main-search__input').addEventListener('keyup', (evt) => {
      if (evt.key === 'Escape') {
        this.querySelector('.main-search__close').dispatchEvent(new Event('click'));
      }
    });

    // Search as you type
    if (this.dataset.quickSearch === 'true') {
      this.initQuickSearch();
    }

    this.showSearchHistory();
  }

  initQuickSearch() {
    const searchInput = this.querySelector('.main-search__input');
    const searchTimeoutThrottle = 500;
    const resultLimit = 8;
    const includeMeta = this.dataset.quickSearchMeta === 'true';
    let searchTimeoutID = -1;
    let searchAbortController = null;

    const handleInputChange = () => {
      const resultsBox = this.querySelector('.main-search__results');
      /* Container of search results */
      const mainSearchResultsContainer = this.querySelector('.main-search__results-container');
      /* Container of search suggestions initial */
      const suggestionsContainer = this.querySelector('.main-search__suggestions');
      const valueToSearch = searchInput.value;

      // Only search if search string longer than 2, and it has changed
      if (valueToSearch.length && valueToSearch !== this.oldSearchValue) {
        // Save previous value
        this.oldSearchValue = valueToSearch;

        // Kill outstanding ajax request
        if (searchAbortController !== null) {
          searchAbortController.abort();
          searchAbortController = null;
        }

        // Kill previous search
        clearTimeout(searchTimeoutID);

        // Create URL for full search results
        const form = searchInput.closest('form');
        const linkURL = new URL(form.action);
        const formParams = new URLSearchParams(new FormData(form));
        formParams.forEach((value, key) => { linkURL.searchParams.set(key, value); });

        // Show loading
        this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--no-results');
        //If loading state: this.classList.add('main-search--loading');
        if (!this.querySelector('.main-search__results-spinner')) {
          resultsBox.innerHTML = '<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>';
        }

        // Do next search (in X milliseconds)
        searchTimeoutID = setTimeout(() => {
          searchAbortController = new AbortController();
          let ajaxUrl;

          if (theme.Shopify.features.predictiveSearch) {
            // use the API
            ajaxUrl = new URL(window.location.protocol + '//' + window.location.host + theme.routes.predictiveSearch);
            ajaxUrl.searchParams.set('q', valueToSearch);
            ajaxUrl.searchParams.set('section_id', 'predictive-search');
            ajaxUrl.searchParams.set('resources[limit]', resultLimit);
            ajaxUrl.searchParams.set('resources[options][fields]', includeMeta ? 'title,product_type,variants.title,vendor,tag,variants.sku' : 'title,product_type,variants.title,vendor');
          } else {
            // use the theme template fallback
            ajaxUrl = new URL(linkURL);
            ajaxUrl.searchParams.set('section_id', 'main-search');
          }

          fetch(ajaxUrl, { method: 'get', signal: searchAbortController.signal })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.text();
            })
            .then((response) => {
              handleSearchSubmit(searchInput)
              const template = document.createElement('template');
              template.innerHTML = response;
              let resultsList = null;
              if (theme.Shopify.features.predictiveSearch) {
                resultsList = template.content.querySelector('.product-grid');
              } else {
                resultsList = template.content.querySelector('.section-search-template .product-grid');
              }

              // reset previous contents
              searchAbortController = null;
              this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--no-results');
              /* After search: Show search results container and hide initial suggestions container */
              if (mainSearchResultsContainer) {
                mainSearchResultsContainer.classList.remove('hidden');
              }
              if (suggestionsContainer) {
                suggestionsContainer.classList.add('hidden');
              }
              resultsBox.innerHTML = '';

              const resultsProducts = document.createElement('div');
              resultsProducts.className = 'main-search__results__products collection-listing';
              resultsProducts.innerHTML = '<div></div>';
              const resultsPages = document.createElement('div');
              resultsPages.className = 'main-search__results__pages';

              resultsProducts.firstElementChild.className = resultsList.className;

              // Convert standard blocks into quick search result format
              resultsList.querySelectorAll('.product-block:not(.collection-block):not(.page-block)').forEach((block, index) => {
                if (index <= resultLimit) {
                  block.classList.add('main-search-result');
                  block.querySelectorAll('.btn.quickbuy-toggle').forEach((el) => el.remove());
                  block.querySelectorAll('.quickbuy-toggle').forEach((el) => el.classList.remove('quickbuy-toggle'));
                  // block.querySelectorAll('.image-cont mcb-quickbuy-button').forEach((el) => el.remove());
                  resultsProducts.firstElementChild.appendChild(block);
                }
              });

              resultsList.querySelectorAll('.product-block.page-block').forEach((block) => {
                const item = document.createElement('a');
                item.className = 'main-search-result main-search-result--page';
                item.href = block.querySelector('a').href;
                item.innerHTML = '<div class="main-search-result__text"></div>';
                item.firstElementChild.innerText = block.querySelector('.page-block__title').innerText;
                resultsPages.appendChild(item);
              });

              // Extract and populate categories in search-sidebar.liquid after search
              const categoriesSidebar = this.querySelector('[data-search-sidebar-categories]');
              if (categoriesSidebar) {
                const collectionBlocks = resultsList.querySelectorAll('[data-collection-product-block]');
                let categoriesHtml = '';
                
                collectionBlocks.forEach((block) => {
                  const link = block.querySelector('[data-collection-product-link]');
                  if (link) {
                    const href = link.href;
                    const title = link.querySelector('[data-collection-product-title]')?.textContent?.trim();
                    categoriesHtml += `<a href="${href}">${title}</a>`;
                  }
                  
                });

                if (categoriesHtml !== '') {
                  categoriesSidebar.innerHTML = categoriesHtml;
                } else {
                  // categoriesSidebar.innerHTML = '<span>-</span>';
                }
              }              

              this.classList.remove('main-search--loading');

              const areProducts = !!resultsProducts.querySelector('.main-search-result');
              const arePages = !!resultsPages.querySelector('.main-search-result');

              const headlineContainer = resultsBox.closest('.main-search__sidebar__headline-container');
              const hrElement = headlineContainer?.querySelector('.main-search__hr');

              if (areProducts || arePages) {
                // Numerous results
                this.classList.add('main-search--has-results');
                if (hrElement) {
                  hrElement.classList.remove('main-search__hr--hide-mobile');
                }
                this.classList.toggle('main-search--results-on-multiple-lines', resultsProducts.querySelectorAll('.product-block').length > 4);
                if (areProducts) {
                  resultsBox.appendChild(resultsProducts);
                }
                if (arePages) {
                  const heading = document.createElement('h6');
                  heading.className = 'main-search-result__heading';
                  heading.innerHTML = theme.strings.generalSearchPages;
                  resultsPages.insertAdjacentElement('afterbegin', heading);
                  resultsBox.appendChild(resultsPages);
                }

                const allLink = document.createElement('a');
                allLink.className = 'main-search__results-all-link btn btn--primary';
                allLink.href = linkURL;
                allLink.innerHTML = theme.strings.generalSearchViewAll;
                resultsBox.appendChild(allLink);
              } else {
                // No results - show nothing
                this.classList.add('main-search--no-results');
                if (hrElement) {
                  hrElement.classList.add('main-search__hr--hide-mobile');
                }
                const emptyMessage = document.createElement('div');
                emptyMessage.className = 'main-search__empty-message';
                emptyMessage.innerHTML = theme.strings.generalSearchNoResultsWithoutTerms;
                resultsBox.appendChild(emptyMessage);
              }
            });
        }, searchTimeoutThrottle);
      } else if (!valueToSearch.length) {
        // Abandon current search
        this.oldSearchValue = valueToSearch;
        if (searchAbortController !== null) {
          searchAbortController.abort();
          searchAbortController = null;
        }
        clearTimeout(searchTimeoutID);

        // Clear results and hide container
        this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--loading');
        resultsBox.innerHTML = '';
        /* When search is cleared: Hide search results container and show initial suggestions container */
        if (mainSearchResultsContainer) {
          mainSearchResultsContainer.classList.add('hidden');
        }
        if (suggestionsContainer) {
          suggestionsContainer.classList.remove('hidden');
        }

        // Clear categories sidebar when search is cleared
        const categoriesSidebar = this.querySelector('[data-search-sidebar-categories]');
        if (categoriesSidebar) {
          categoriesSidebar.innerHTML = '';
        }
      }
    };

    /* Save search history for recent searches in session storage */
    const handleSearchSubmit = (searchInput) => {    
      const term = searchInput.value.trim();
      if (term.length > 2) {
        const key = 'mainSearchHistory';
        let history = JSON.parse(sessionStorage.getItem(key)) || [];
  
        // Limit to 5 recent searches
        history = [term, ...history.filter(item => item !== term)].slice(0, 5);
  
        sessionStorage.setItem(key, JSON.stringify(history));
      }
    }

    searchInput.addEventListener('keyup', handleInputChange.bind(this));
    searchInput.addEventListener('change', handleInputChange.bind(this));
  }

  /* Show search history in search sidebar */
  showSearchHistory() {
    const searchSidebarRecentSearchesContainer = document.querySelectorAll('[data-search-sidebar-recent-searches-container]');
    const searchSidebarRecentSearches = this.querySelectorAll('[data-search-sidebar-recent-searches]');
    
    if (!searchSidebarRecentSearchesContainer) return;
    
    const key = 'mainSearchHistory';
    const history = JSON.parse(sessionStorage.getItem(key)) || [];
    
    let html = '';
    
    if (history.length > 0) {
      html = history.map(item => `<span class="search-history__item">${item}</span>`).join('');
      searchSidebarRecentSearchesContainer.forEach(container => container.classList.remove('hidden'));
    } else {
      searchSidebarRecentSearchesContainer.forEach(container => container.classList.add('hidden'));
    }

    searchSidebarRecentSearches.forEach(element => {
      element.innerHTML = html;

      if (history.length === 0) return;
      
        const searchInput = this.querySelector('.main-search__input');
        if (!searchInput) return;
  
        element.querySelectorAll('.search-history__item').forEach(btn => {
          btn.addEventListener('click', () => {
            searchInput.value = btn.textContent;
            searchInput.dispatchEvent(new Event('change'));
            searchInput.focus();
          });
        });
    });
  }
};

window.customElements.define('main-search', MainSearch);
